
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.2 7.8h-1.627a1.074 1.074 0 00-.4 2.07l1.652.66a1.074 1.074 0 01-.4 2.07H9.8M11 7.8v-.6M11 13.2v-.6","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.4 10.2A3.6 3.6 0 0017 6.805V5.4a1.2 1.2 0 00-1.2-1.2H6.2A1.2 1.2 0 005 5.4v1.405a3.6 3.6 0 000 6.789v1.405a1.2 1.2 0 001.2 1.2h9.6A1.2 1.2 0 0017 15v-1.405a3.6 3.6 0 002.4-3.394z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    